/**
 * Currency code to symbol mapping for display.
 * Add more codes as needed.
 */
export const CURRENCY_SYMBOLS = {
  INR: '₹',
  USD: '$',
  EUR: '€',
  GBP: '£',
  JPY: '¥',
  AUD: 'A$',
  CAD: 'C$',
  CHF: 'CHF',
  CNY: '¥',
  SGD: 'S$',
  AED: 'د.إ',
  SAR: '﷼',
};

/**
 * Returns the currency symbol for a given currency code.
 * @param {string} code - ISO 4217 currency code (e.g. 'INR', 'USD')
 * @returns {string} Symbol or code with space if unknown
 */
export function getCurrencySymbol(code) {
  if (!code || typeof code !== 'string') return '';
  const upper = code.toUpperCase();
  return CURRENCY_SYMBOLS[upper] ?? `${upper} `;
}
